export default __webpack_public_path__ + "img/icon-sound.355ff80a.svg";